var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39233e-05 6.00039C0.00069952 5.85675 0.062089 5.7192 0.170828 5.61779L5.99864 0.165857C6.05243 0.11391 6.11673 0.0724938 6.1878 0.0440221C6.25887 0.0155505 6.33528 0.000591719 6.41259 1.7202e-05C6.4899 -0.000557315 6.56656 0.0132644 6.6381 0.0406763C6.70964 0.0680882 6.77464 0.108542 6.82931 0.159684C6.88397 0.210825 6.92722 0.271631 6.95652 0.33856C6.98582 0.405489 7.0006 0.477203 6.99998 0.549525C6.99937 0.621848 6.98338 0.693332 6.95294 0.759817C6.92251 0.826302 6.87824 0.886457 6.82271 0.93678L1.40387 6.00612L6.82271 11.0755C6.92914 11.1782 6.9881 11.316 6.98689 11.4591C6.98567 11.6022 6.92437 11.7391 6.81621 11.8403C6.70806 11.9415 6.56171 11.9988 6.40875 12C6.2558 12.0011 6.1085 11.946 5.99864 11.8464L0.170828 6.39445C0.115506 6.34289 0.0718718 6.28141 0.0425339 6.2137C0.013196 6.14599 -0.00124216 6.07344 8.39233e-05 6.00039Z",
    fill: "#285680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.88b43dcb57688977868c108244c1ab52.svg";
export { ForwardRef as ReactComponent };